import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum ActionsInstallmentStatus {
  Canceled = 4,
  Accredit = 6,
  PaidByOtherWay = 8,
}
EnumDescriptions.setDescriptions(ActionsInstallmentStatus, [
  i18n.t('enums.canceled_action'),
  i18n.t('enums.accredit_action'),
  i18n.t('enums.paid_by_other_way_action'),
]);
